import CustomModal from "@components/CustomModal";

import usePublishPost from "./hooks/usePublishPost";
import PublishPostView from "./view";

export default function PublishPostModal({ modalRef }) {
    const {
        open,
        loading,
        configRef,
        communityRef,
        exerciseRegistry,
        setExerciseRegistry,
        uploadBusy,
        handleUploadBusyChange,
        handleSubmit,
        handleClose,
    } = usePublishPost({ modalRef });

    return (
        <CustomModal
            maxWidth={520}
            bottomButtonSumbitText="Publicar agora"
            bottomButtonCancelText="Cancelar"
            loading={loading}
            disabled={uploadBusy}
            title="Publicar novo post"
            handleSubmit={handleSubmit}
            open={open}
            handleClose={handleClose}
            bodyComponent={
                open ? (
                    <PublishPostView
                        configRef={configRef}
                        communityRef={communityRef}
                        exerciseRegistry={exerciseRegistry}
                        onExerciseRegistryChange={setExerciseRegistry}
                        onUploadBusyChange={handleUploadBusyChange}
                    />
                ) : null
            }
        />
    );
}
